/**
 * @generated SignedSource<<0770928fd30760dad9b6c5ffb621243a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VerifyPhoneCodeInput = {
  code: string;
  phoneNumber: string;
};
export type useVerifyPhoneCodeMutation$variables = {
  input: VerifyPhoneCodeInput;
};
export type useVerifyPhoneCodeMutation$data = {
  readonly responsePayload: {
    readonly assignmentToken: string | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly session: {
      readonly currentClientProfile: {
        readonly active?: boolean;
        readonly id?: string;
        readonly member: {
          readonly __typename: "AnonymousCustomer";
        } | {
          readonly __typename: "Customer";
          readonly departmentMemberProfiles: ReadonlyArray<{
            readonly department?: {
              readonly slug: string;
            } | null | undefined;
            readonly ghinNumber?: number | null | undefined;
          } | null | undefined> | null | undefined;
          readonly email: string | null | undefined;
          readonly firstName: string | null | undefined;
          readonly id: string;
          readonly lastName: string | null | undefined;
          readonly membershipType: {
            readonly id: string;
          } | null | undefined;
          readonly phoneNumber: {
            readonly nationalNumber: string;
          } | null | undefined;
          readonly profileImage: {
            readonly publicId: string;
          } | null | undefined;
        } | {
          readonly __typename: "Member";
          readonly departmentMemberProfiles: ReadonlyArray<{
            readonly department?: {
              readonly slug: string;
            } | null | undefined;
            readonly ghinNumber?: number | null | undefined;
          } | null | undefined> | null | undefined;
          readonly email: string | null | undefined;
          readonly firstName: string | null | undefined;
          readonly id: string;
          readonly lastName: string | null | undefined;
          readonly memberGroups: ReadonlyArray<{
            readonly id: string;
          } | null | undefined> | null | undefined;
          readonly membershipType: {
            readonly id: string;
          } | null | undefined;
          readonly phoneNumber: {
            readonly nationalNumber: string;
          } | null | undefined;
          readonly profileImage: {
            readonly publicId: string;
          } | null | undefined;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined;
      } | null | undefined;
      readonly masquerader: {
        readonly email: string | null | undefined;
        readonly username: string | null | undefined;
      } | null | undefined;
      readonly user: {
        readonly __typename: string;
        readonly email: string | null | undefined;
        readonly id: string;
        readonly memberProfiles?: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly member: {
                readonly club: {
                  readonly id: string;
                  readonly logoImage: {
                    readonly publicId: string;
                  } | null | undefined;
                  readonly name: string;
                  readonly slug: string;
                };
              } | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly metadata?: {
          readonly hasSeenNotificationNudgeModal: boolean | null | undefined;
        } | null | undefined;
        readonly username: string | null | undefined;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"useSyncAnalyticsTrackingPermission_session">;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useVerifyPhoneCodeMutation = {
  response: useVerifyPhoneCodeMutation$data;
  variables: useVerifyPhoneCodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assignmentToken",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowUnauthenticatedAnalyticsTracking",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requiresAnalyticsTrackingConsent",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "analyticsTrackingConsentedAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultCountryCode",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    }
  ],
  "type": "MemberProfile",
  "abstractKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nationalNumber",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "PhoneNumber",
  "kind": "LinkedField",
  "name": "phoneNumber",
  "plural": false,
  "selections": [
    (v14/*: any*/)
  ],
  "storageKey": null
},
v16 = [
  {
    "alias": "publicId",
    "args": null,
    "kind": "ScalarField",
    "name": "renderingKey",
    "storageKey": null
  }
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "profileImage",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v18 = [
  (v9/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "CustomerType",
  "kind": "LinkedField",
  "name": "membershipType",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v20 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "GOLF"
  }
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ghinNumber",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": (v20/*: any*/),
  "concreteType": null,
  "kind": "LinkedField",
  "name": "departmentMemberProfiles",
  "plural": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v21/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Department",
          "kind": "LinkedField",
          "name": "department",
          "plural": false,
          "selections": [
            (v22/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "GolfMemberProfile",
      "abstractKey": null
    }
  ],
  "storageKey": "departmentMemberProfiles(type:\"GOLF\")"
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "MembershipType",
  "kind": "LinkedField",
  "name": "membershipType",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberGroup",
  "kind": "LinkedField",
  "name": "memberGroups",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v27 = [
  {
    "kind": "Literal",
    "name": "active",
    "value": true
  }
],
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "Club",
  "kind": "LinkedField",
  "name": "club",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    (v22/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "logoImage",
      "plural": false,
      "selections": (v16/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasSeenNotificationNudgeModal",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v33 = {
  "kind": "InlineFragment",
  "selections": (v18/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "PhoneNumber",
  "kind": "LinkedField",
  "name": "phoneNumber",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": (v20/*: any*/),
  "concreteType": null,
  "kind": "LinkedField",
  "name": "departmentMemberProfiles",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v21/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Department",
          "kind": "LinkedField",
          "name": "department",
          "plural": false,
          "selections": [
            (v22/*: any*/),
            (v9/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "GolfMemberProfile",
      "abstractKey": null
    },
    (v9/*: any*/)
  ],
  "storageKey": "departmentMemberProfiles(type:\"GOLF\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useVerifyPhoneCodeMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "VerifyPhoneCodePayload",
        "kind": "LinkedField",
        "name": "verifyPhoneCode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Session",
            "kind": "LinkedField",
            "name": "session",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "useSyncAnalyticsTrackingPermission_session",
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "MemberUser",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "currentClientProfile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "member",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Club",
                            "kind": "LinkedField",
                            "name": "club",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "args": null,
                "argumentDefinitions": []
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "currentClientProfile",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "member",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v6/*: any*/)
                        ],
                        "type": "AnonymousCustomer",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v6/*: any*/),
                          (v9/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v15/*: any*/),
                          (v17/*: any*/),
                          (v19/*: any*/),
                          (v23/*: any*/)
                        ],
                        "type": "Customer",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v23/*: any*/),
                          (v6/*: any*/),
                          (v9/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v15/*: any*/),
                          (v17/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/)
                        ],
                        "type": "Member",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "masquerader",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v26/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v9/*: any*/),
                  (v13/*: any*/),
                  (v26/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": (v27/*: any*/),
                        "concreteType": "MemberProfileConnection",
                        "kind": "LinkedField",
                        "name": "memberProfiles",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberProfileEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MemberProfile",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "member",
                                    "plural": false,
                                    "selections": [
                                      (v28/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "memberProfiles(active:true)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          (v29/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "MemberUser",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useVerifyPhoneCodeMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "VerifyPhoneCodePayload",
        "kind": "LinkedField",
        "name": "verifyPhoneCode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Session",
            "kind": "LinkedField",
            "name": "session",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v29/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v27/*: any*/),
                        "concreteType": "MemberProfileConnection",
                        "kind": "LinkedField",
                        "name": "memberProfiles",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberProfileEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MemberProfile",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "member",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v28/*: any*/),
                                      (v33/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v9/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "memberProfiles(active:true)"
                      }
                    ],
                    "type": "MemberUser",
                    "abstractKey": null
                  },
                  (v9/*: any*/),
                  (v13/*: any*/),
                  (v26/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "currentClientProfile",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "member",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Club",
                        "kind": "LinkedField",
                        "name": "club",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isClient"
                      },
                      (v33/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v34/*: any*/),
                          (v17/*: any*/),
                          (v19/*: any*/),
                          (v35/*: any*/)
                        ],
                        "type": "Customer",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v35/*: any*/),
                          (v9/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v34/*: any*/),
                          (v17/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/)
                        ],
                        "type": "Member",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v33/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "masquerader",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v13/*: any*/),
                  (v26/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6543155360c81c7ffe96092a8afde64a",
    "id": null,
    "metadata": {},
    "name": "useVerifyPhoneCodeMutation",
    "operationKind": "mutation",
    "text": "mutation useVerifyPhoneCodeMutation(\n  $input: VerifyPhoneCodeInput!\n) {\n  responsePayload: verifyPhoneCode(input: $input) {\n    success\n    assignmentToken\n    session {\n      ...useSyncAnalyticsTrackingPermission_session\n      currentClientProfile {\n        __typename\n        ... on MemberProfile {\n          id\n          active\n        }\n        member {\n          __typename\n          __isClient: __typename\n          ... on AnonymousCustomer {\n            __typename\n          }\n          ... on Customer {\n            __typename\n            id\n            firstName\n            lastName\n            email\n            phoneNumber {\n              nationalNumber\n              id\n            }\n            profileImage {\n              publicId: renderingKey\n            }\n            membershipType {\n              id\n            }\n            departmentMemberProfiles(type: GOLF) {\n              __typename\n              ... on GolfMemberProfile {\n                ghinNumber\n                department {\n                  slug\n                  id\n                }\n              }\n              id\n            }\n          }\n          ... on Member {\n            departmentMemberProfiles(type: GOLF) {\n              __typename\n              ... on GolfMemberProfile {\n                ghinNumber\n                department {\n                  slug\n                  id\n                }\n              }\n              id\n            }\n            __typename\n            id\n            firstName\n            lastName\n            email\n            phoneNumber {\n              nationalNumber\n              id\n            }\n            profileImage {\n              publicId: renderingKey\n            }\n            membershipType {\n              id\n            }\n            memberGroups {\n              id\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      masquerader {\n        __typename\n        email\n        username\n        id\n      }\n      user {\n        __typename\n        id\n        email\n        username\n        ... on MemberUser {\n          memberProfiles(active: true) {\n            edges {\n              node {\n                member {\n                  __typename\n                  club {\n                    id\n                    name\n                    slug\n                    logoImage {\n                      publicId: renderingKey\n                    }\n                  }\n                  ... on Node {\n                    __isNode: __typename\n                    id\n                  }\n                }\n                id\n              }\n            }\n          }\n          metadata {\n            hasSeenNotificationNudgeModal\n          }\n        }\n      }\n    }\n    errors {\n      __typename\n      field\n      code\n      message\n    }\n  }\n}\n\nfragment useSyncAnalyticsTrackingPermission_session on Session {\n  allowUnauthenticatedAnalyticsTracking\n  requiresAnalyticsTrackingConsent\n  user {\n    __typename\n    ... on MemberUser {\n      metadata {\n        analyticsTrackingConsentedAt\n      }\n    }\n    id\n  }\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        defaultCountryCode\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "83719f599660a0466df9d31273bd3837";

export default node;
